import { createI18nText } from '@hilma/netina2all';

const countdownText = createI18nText({
	he: {
		days: 'ימים',
		hours: 'שעות',
		minutes: 'דקות',
		closesInAnother: 'הרכישה נסגרת בעוד',
		opensInAnother: 'הרכישה נפתחת בעוד',
	},
	en: {
		days: 'Days',
		hours: 'Hours',
		minutes: 'Minutes',
		closesInAnother: 'Purchases can be made for another',
		opensInAnother: 'Purchases can be made in another',
	}
});

export default countdownText;